<nz-page-header nzTitle="Ticket invoice Approval List"></nz-page-header>


<!-- Submit Section -->
<div class="row mt-4" *ngIf="data">
	<div class="col">
		<nz-card>

			<ng-container *ngIf="hasRejections">
				<nz-form-item>
					<nz-form-label [nzSpan]="24" nzRequired>
						Rejection Reason
					</nz-form-label>
					<nz-form-control [nzSpan]="24" nzErrorTip="A reason is required when rejecting entries">
						<textarea
							nz-input
							[(ngModel)]="rejectionReason"
							[nzAutosize]="{ minRows: 3, maxRows: 6 }"
							placeholder="Please provide a reason for the rejected entries...">
						</textarea>
					</nz-form-control>
				</nz-form-item>
			</ng-container>

			<div class="submit-footer">
				<div class="submit-footer__summary">
					<nz-tag nzColor="success">Approved: {{ approvedCount }}</nz-tag>
					<nz-tag nzColor="error">Rejected: {{ rejectedCount }}</nz-tag>
					<nz-tag nzColor="warning">Pending: {{ pendingCount }}</nz-tag>
				</div>
				<button
					nz-button
					nzType="primary"
					[disabled]="!canSubmit"
					(click)="onSubmit()">
					Submit
				</button>
			</div>

		</nz-card>
	</div>
</div>

<div class="row mt-3">
	<div class="col">
		<app-table
			[data]="data"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[loading]="loading"
			[disablePaging]="false"
			(onUpdateRequired)="doFetchUploads($event)">
			<ng-template #recipientNameRef let-row="row">
				<td *ngIf="row.recipientDynamicGenetic">{{row.recipientMember.name}} {{row.recipientMember.surname}}</td>
				<td *ngIf="row.recipientDynamicGenetic">{{row.recipientDynamicGenetic.name}}</td>
			</ng-template>
			<ng-template #actionRef let-row="row">
				<td>
				<button nz-button
					[nzType]="row.statusApproval === 'Approved' ? 'primary' : 'default'"
					(click)="approve(row)">
					Approve
				</button>
				<button nz-button
					[nzType]="row.statusApproval === 'Rejected' ? 'primary' : 'default'"
					[nzDanger]="row.statusApproval === 'Rejected'"
					(click)="reject(row)">
					Reject
				</button>
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
